export type Identifiable = string | { id: string };

export const toId = (identifiable: Identifiable): string => {
	if (typeof identifiable === "string") {
		return identifiable;
	}

	return identifiable.id;
};
